module.exports = __webpack_public_path__ + "media/images/logo-668-60ba1fa4bd34089d09d08b8853edb0d8.jpg";